<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickSupplierProfileUpdate)" autocomplete="off">
          <vx-card class="mb-8" :title="form.status ? `Supplier Status: ${form.status.name}` : ''"
            :titleColor="form.status.id === 3 ? 'primary' : 'warning'">
            <template slot="actions">
              <div class="dropdown-button-container w-16" v-if="form.status">
                <vs-dropdown>
                  <a class="flex items-center" href="#">
                    Status
                    <i class="material-icons"> expand_more </i>
                  </a>
                  <vs-dropdown-menu class="w-64">

                    <span v-for="(status, index) in status_list" :key="index">
                      <vs-dropdown-item v-if="status.before_status.includes(form.status.id)" disabled
                        @click="supplierStatusChangeConfirmDialog(status.value)" :class="`text-${status.color}`">
                        {{ status.label }}
                      </vs-dropdown-item>
                    </span>

                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </template>
            <div class="vx-row mb-3 hidden">
              <div class="vx-col w-full">
                <div class="float-right mr-4">
                  <vs-chip class="float-right" transparent>
                    Supplier Status: <span class="font-bold">{{ form.status.name || 'N/A' }}</span>
                  </vs-chip>
                </div>
                <vs-chip class="float-right" transparent v-if="form.is_supplier_activated === 1" color="success">
                  Portal Status: Active
                </vs-chip>
                <vs-chip class="float-right" transparent v-if="form.is_supplier_activated === 0" color="danger">
                  Portal Status: Suspend
                </vs-chip>
              </div>
            </div>
            <div class="vx-row mb-3 mt-8">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                  <small class="label">Company Name</small>
                  <vs-input type="text" name="company_name" class="w-full" v-model="form.company_name"
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                  <small class="label">Country</small>
                  <v-select :filter-by="myFilter" @input="selectCountry" :clearable="false" name="country" placeholder=""
                    label="name" v-model="form.country" :reduce="option => option.name" :options="countryCodes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{ option.name }} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <ValidationProvider vid="telephone_country_code" name="telephone_country_code" rules="required"
                      v-slot="{ errors }">
                      <small class="label">Country Code</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="telephone_country_code" placeholder=""
                        label="isd_code" v-model="form.country_code_telephone" :reduce="option => option.isd_code"
                        :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{ option.isd_code }} - {{ option.name }} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-2/3">
                    <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15"
                      v-slot="{ errors }">
                      <small class="label">Telephone</small>
                      <vs-input name="site_telephone" class="w-full required" label="" v-model="form.telephone"
                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <ValidationProvider vid="fax_country_code" name="fax_country_code" rules="" v-slot="{ errors }">
                      <small class="label">Country Code</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="fax_country_code" placeholder=""
                        label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code"
                        :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{ option.isd_code }} - {{ option.name }} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-2/3">
                    <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                      <small class="label">Fax</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax" />
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/5 md:mb-0">
                <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
                  <small class="label">Do you have a company VAT registration?</small>
                  <vs-switch v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/5">
                <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country"
                  name="is_vat_registration_country" rules="required" v-slot="{ errors }">
                  <small class="label">If yes, In which country are you registered</small>
                  <v-select :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder=""
                    label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name"
                    :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text"
                  name="is_vat_registration_text" rules="required" v-slot="{ errors }">
                  <small class="label">If yes, company VAT registration</small>
                  <vs-input type="text" name="is_vat_registration_text" class="w-full"
                    v-model="form.is_vat_registration_text" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/5 md:mb-0">
                <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
                  <small class="label">Do you have a company registration number?</small>
                  <vs-switch v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/5">
                <ValidationProvider v-if="form.is_registration" vid="is_registration_country"
                  name="is_registration_country" rules="required" v-slot="{ errors }">
                  <small class="label">If Yes, In which country are you registered</small>
                  <v-select :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder=""
                    label="name" v-model="form.is_registration_country" :reduce="option => option.name"
                    :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text"
                  rules="required" v-slot="{ errors }">
                  <small class="label">If yes, company registration number</small>
                  <vs-input type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 md:mb-0">
                <ValidationProvider vid="supplier_status" name="supplier_status" rules="required" v-slot="{ errors }">
                  <small class="label">Supplier Type</small>
                  <v-select label="name" :closeOnSelect="true" v-model="form.supplier_status"
                    :options="supplierStatusList" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.name" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider v-if="form.supplier_status === 'trader' || form.supplier_status === 'packer'"
                  vid="supplier_identity" name="supplier_identity" rules="required" v-slot="{ errors }">
                  <small class="label">Identity of manufacturer</small>
                  <vs-input type="text" name="supplier_identity" class="w-full" v-model="form.supplier_identity" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>

          <vx-card class="my-8">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/5 md:mb-0">
                <ValidationProvider vid="is_product_liability_insurance_cover" name="is_product_liability_insurance_cover"
                  rules="" v-slot="{ errors }">
                  <small class="label">1.1 Do you have Product Liability Insurance Cover? </small>
                  <vs-switch v-model="supplier_additional_detail.is_product_liability_insurance_cover" icon-pack="feather"
                    vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-4/5 w-full md:mb-0">
                <ValidationProvider v-if="supplier_additional_detail.is_product_liability_insurance_cover"
                  vid="is_product_liability_insurance_cover_text" name="is_product_liability_insurance_cover_text"
                  rules="required" v-slot="{ errors }">
                  <small class="label">If yes, state limit of Liability ({{ $store.getters.system_currency }})</small>
                  <vs-input type="text" name="is_product_liability_insurance_cover_text" class="w-full"
                    v-model="supplier_additional_detail.is_product_liability_insurance_cover_text" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

          </vx-card>

          <vx-card class="mt-8">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button v-if="form.status.id !== 3" @click="openApprovalConfirm" class="float-right mt-2 ml-4 hidden"
                type="border" color="primary" disabled>
                Approve & Save Supplier
              </vs-button>
              <vs-button button="submit" class="ml-4 mt-2" disabled>Save Changes</vs-button>
            </div>
          </vx-card>

          <vx-card class="mt-8"
            :title="`Supplier Portal Status: ${form.is_supplier_activated === 1 ? 'Activated' : 'Suspended'}`"
            :titleColor="form.is_supplier_activated === 1 ? 'primary' : 'warning'">
            <div class="vx-row mb-3">
              <span style="display: none">{{ form.status.id }}</span>
              <span style="display: none">{{ form.is_supplier_activated }}</span>
              <vs-button v-if="form.is_supplier_activated === 1" @click="openDeActiveConfirm"
                class="float-right mt-2 ml-4 " type="border" color="danger" disabled>Suspend Supplier Portal</vs-button>
              <vs-button v-if="form.is_supplier_activated === 0" @click="openReActiveConfirm"
                class="float-right mt-2 ml-4" type="border" color="primary" disabled>Reinstate Supplier Portal</vs-button>
            </div>
          </vx-card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const SupplierRepository = RepositoryFactory.get('supplier');
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
const supplierStatusTypesRepository = RepositoryFactory.get('supplierTypes')

import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileUploader from '@/components/shared/FileUploader'


function initialState() {
  return {
    countryCodes: [],
    company_name: null,
    form: {
      is_vat_registration: false,
      is_registration: false,
      sage_id: '',
      status: {
        id: 1
      }
    },
    supplier_additional_detail: {
      is_product_liability_insurance_cover: false,
      is_sedex_member: false,
      is_sedex_member_file: ''
    },
    status_list: [
      { label: 'Approve Supplier', id: '1', value: 'approve', before_status: [2, 4], color: 'primary' },
      { label: 'Reject Supplier', id: '4', value: 'not-approve', before_status: [2], color: 'danger' },
      { label: 'Hold / Suspend Supplier', id: '5', value: 'on-hold', before_status: [3], color: 'warning' },
      { label: 'Re-Instate Supplier', id: '1', value: 're-instate', before_status: [5], color: 'primary' },
    ],
    supplierStatusList: []
  }
}
export default {
  name: 'ProfileDetailsView',
  mixins: [SuccessMessage, ErrorMessages],
  data() {
    return initialState()
  },
  props: {
    tenant_id: {
      required: true,
      default: ''
    },
    supplier_id: {
      required: true,
      default: ''
    }
  },
  components: {
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    FileUploader,
  },
  computed: {
  },
  methods: {
    async loadData() {
      this.$vs.loading()
      // this.countryCodes =  (await SupplierManufactureRepository.getCountryCodes()).data.data

      const { data } = (await SupplierRepository.getSupplierDetails(this.tenant_id, this.supplier_id)).data

      if (data.is_complete_details === 1) {
        this.form = data
        this.company_name = data.company_name
        this.supplier_additional_detail = this.form.supplier_additional_detail
        this.form.status = data.status
        this.form.is_supplier_activated = data.is_supplier_activated
      } else {
        this.form.company_name = data.company_name
        this.company_name = data.company_name
        this.form.company_name_unique = data.company_name_unique
        this.form.telephone = data.telephone
        this.form.country_code_telephone = data.country_code_telephone
        this.form.status = data.status
        this.form.is_supplier_activated = data.is_supplier_activated
        this.form.sage_id = data.sage_id
      }
      this.$vs.loading.close()
    },
    // async loadSupplierStatusTypes() {
    //   const { data } = await supplierStatusTypesRepository.getListOfSupplierStatusTypes()
    //   this.supplierStatusList = data.data
    // },
    selectCountry(country) {
      let obj = this.countryCodes.find(o => o.name === country);
      this.form.country_code_telephone = obj.isd_code
      this.form.country_code_fax = obj.isd_code
    },
    successUpload() {
      this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur' })
    },
    addNewGfsi: function () {
      this.supplier_GFSIs.push(
        { type: 'GFSI', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null }
      )
    },
    addNewAccreditations: function () {
      this.supplier_other_accreditations.push(
        { type: 'Other', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null }
      )
    },
    deleteGfsi: function (index) {
      this.supplier_GFSIs.splice(index, 1)
    },
    deleteAccreditations: function (index) {
      this.supplier_other_accreditations.splice(index, 1)
    },


    async onClickSupplierProfileUpdate() {
      let payload = this.form
      payload.supplier_additional_detail = this.supplier_additional_detail
      this.$vs.loading();
      try {
        const change = await SupplierRepository.updateSupplierBasicDetails(this.supplier_id, payload);
        this.$emit('refreshData')
        this.showSuccessMessage('Supplier Profile Update Successfully!')
        await this.loadData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    openApprovalConfirm() {
      this.$refs.form.validate().then(async (valid) => {
        if (valid) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Confirm',
            text: `Are you sure you want to approve/re-instate this supplier?`,
            accept: this.onClickApproveSupplier
          })
        }
      });
    },
    openReActiveConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm',
        text: 'Are you sure you want to re-active this supplier?',
        accept: this.onClickReActiveSupplier
      })
    },
    openDeActiveConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to de-active this supplier?',
        accept: this.onClickDeActiveSupplier
      })
    },
    supplierStatusChangeConfirmDialog(status) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm',
        text: 'Are you sure you want to change the status?',
        accept: this.changeSupplierStatus,
        parameters: [status]
      })
    },
    async changeSupplierStatus(params) {
      const vue = this;
      this.$vs.loading();
      try {
        await SupplierRepository.changeSupplierstatus(this.supplier_id, params[0])
        this.showSuccessMessage('Supplier status changed successfully');
        await this.loadData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async onClickApproveSupplier() {
      const vue = this;
      this.$vs.loading();
      try {
        let payload = this.form
        payload.supplier_additional_detail = this.supplier_additional_detail
        await SupplierRepository.approveSupplier(this.supplier_id, payload)
        this.$emit('refreshData')
        this.showSuccessMessage('The selected supplier was successfully approved');
        await this.loadData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async onClickReActiveSupplier() {
      const vue = this;
      this.$vs.loading();
      try {
        await SupplierRepository.ReActiveSupplier(this.supplier_id)
        this.showSuccessMessage('The selected supplier was successfully re-activated');
        this.$router.go(0);
        await this.loadData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async onClickDeActiveSupplier() {
      const vue = this;
      this.$vs.loading();
      try {
        await SupplierRepository.DeActivateSupplier(this.supplier_id)
        this.showSuccessMessage('This will  disable access to all users in the supplier. Proceed?');
        this.$router.go(0);
        await this.loadData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
  },
  async mounted() {
    await this.loadData()
    // await this.loadSupplierStatusTypes()
  }
}
</script>

<style lang="scss">
#customer-profile-tabs {
  width: 100%;

  .vs-tabs--ul {
    display: flex;
  }

  .vs-tabs-position-bottom .vs-tabs--ul,
  .vs-tabs-position-top .vs-tabs--ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap !important;
    justify-content: space-evenly;
  }

  .vs-tabs--li {
    flex-grow: 1 !important;
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--li.activeChild {
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-style: solid;
  }
}
</style>
